import React from 'react';
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const OrganizationUnitSocialInfoComponent = ({ itemIndex, deleteSelectedSocialProfiles, getIsSocialProfilesRecordDeletable, onFormSocialProfileItemChange, handleClose, handleOpen, openConfirmation, selectedSocialProfile, socialProfileType }: any) => {

  return (
        <>
   <div className=' shadow-card border-2 rounded-lg mb-4 p-2'>
            
              <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <div>
      <InputLabelContainer label="SI.NO" />
{itemIndex + 1}</div>
   
      <InputContainer
          label="Social Profile Type"
          labelField="Text"
          list={socialProfileType}
          onValueChange={(event: any, newValue: any) => {
            onFormSocialProfileItemChange({
              value: event.target.value,
              field: 'SocialProfileTypeId',
              idx: itemIndex
            });
          }}
          optionName='Choose SocialProfileType'
          type="select"
          value={selectedSocialProfile?.SocialProfileTypeId}
          valueField="Value"
      />
   
      <InputContainer
          label="Social ProfileUrl"
          labelField="Social ProfileUrl"
          onValueChange={(event: any, newValue: any) => {
            onFormSocialProfileItemChange({
              value: event.target.value,
              field: 'SocialProfileUrl',
              idx: itemIndex
            });
          }}
          type="text"
          value={selectedSocialProfile?.SocialProfileUrl}
      />
    
      <InputContainer
          label="Name"
          labelField="Name"
          onValueChange={(event: any, newValue: any) => {
            onFormSocialProfileItemChange({
              value: event.target.value,
              field: 'Name',
              idx: itemIndex
            });
          }}
          type="text"
          value={selectedSocialProfile?.Name}
      />
    <div className='col-span-full'>
      <InputContainer
          label="Description"
          labelField="Description"
          onValueChange={(event: any, newValue: any) => {
            onFormSocialProfileItemChange({
              value: event.target.value,
              field: 'Description',
              idx: itemIndex
            });
          }}
          type="text"
          value={selectedSocialProfile?.Description}
      /></div>
  
    </div> </div>
            
                
</>
  )
}
export default OrganizationUnitSocialInfoComponent;
